import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import BeatLoader from 'react-spinners/BeatLoader';
import { UiIcon } from 'shared/uikit';
import { COLORS, ICONS } from 'shared/constants';

import './styles.scss';

type PropsType = {
    label?: React.ReactNode;
    onClick?: (event: React.SyntheticEvent) => void;
    isSubmit?: boolean;
    isLarge?: boolean;
    isSmall?: boolean;
    isTiny?: boolean;
    isLoading?: boolean;
    isOutline?: boolean;
    isTranslucent?: boolean;
    isLight?: boolean;
    isDanger?: boolean;
    isDisabled?: boolean;
    isTransparent?: boolean;
    isSecondary?: boolean;
    isLink?: boolean;
    isText?: boolean;
    className?: string;
    iconBefore?: React.ReactNode | null;
    iconAfter?: React.ReactNode | null;
    style?: React.CSSProperties;
    children?: React.ReactNode;
    iconName?: string;
    iconSize?: number;
}

export const UiButton = observer((
    {
        label = 'Кнопка',
        isLarge = false,
        isSubmit = false,
        isSmall = false,
        className = '',
        isTiny = false,
        isOutline = false,
        isTranslucent = false,
        isLight = false,
        isDanger = false,
        isTransparent = false,
        isSecondary = false,
        isLoading = false,
        isDisabled = false,
        isLink = false,
        isText = false,
        iconBefore = null,
        iconAfter = null,
        iconName = "",
        iconSize = 0,
        style = {},
        onClick,
        children
    }: PropsType
) => {
    const classNames = useMemo(() => classnames('ui-button', className, {
        'ui-button--disabled': isDisabled,
        'ui-button--large': isLarge,
        'ui-button--small': isSmall,
        'ui-button--tiny': isTiny,
        'ui-button--outline': isOutline,
        'ui-button--link': isLink,
        'ui-button--text': isText,
        'ui-button--danger': isDanger,
        'ui-button--translucent': isTranslucent,
        'ui-button--light': isLight,
        'ui-button--transparent': isTransparent,
        'ui-button--secondary': isSecondary,
        'ui-button--width': style?.width,
        'ui-button--icon': iconName,
    }), [isLarge, isDanger, isSmall, isTiny, isOutline, isLink, isText, isTranslucent, className, style, isLight, isTransparent, isSecondary, isDisabled, iconName]);

    const content = useMemo(() => {
        if (isLoading) {
            return <BeatLoader color={isOutline ? COLORS.BLACK : COLORS.WHITE} size={10}/>;
        }
        return (
            <>
                {iconBefore && <span className='ui-button-icon--before'>{iconBefore}</span>}
                <span>{label}</span>
                {iconAfter && <span className='ui-button-icon--after'>{iconAfter}</span>}
            </>
        );
    }, [label, iconAfter, iconBefore, isLoading, isOutline]);

    return (
        <button
            onClick={isDisabled ? undefined : onClick}
            className={classNames} style={style}
            type={isSubmit ? 'submit' : 'button'}
        >
            {
                iconName && (
                    <UiIcon
                        size={iconSize}
                        icon={ICONS[iconName as keyof typeof ICONS]}
                    />
                )
            }

            {content}
            {children}
        </button>
    );
})
